import useTranslation from 'next-translate/useTranslation';
import React, { Fragment } from 'react';
import { OilKm, OilViscosity } from 'types/Oil';
import { SelectItem } from '../CategoryFilter.styled';

type Props = {
  oilKm: OilKm;
  oilViscosity: OilViscosity;
  selectedOilKm: number | null;
  selectedOilViscosity: string | null;
  setSelectedOilKm: React.Dispatch<React.SetStateAction<number | null>>;
  setSelectedOilViscosity: React.Dispatch<React.SetStateAction<string | null>>;
  setCurrent: React.Dispatch<React.SetStateAction<number>>;
};

export default React.memo(function OilFilter({
  oilKm,
  oilViscosity,
  selectedOilKm,
  selectedOilViscosity,
  setSelectedOilKm,
  setSelectedOilViscosity,
  setCurrent,
}: Props) {
  const { t } = useTranslation('common');

  const oilKmOptions = oilKm.power.map((km) => ({
    label: km,
    value: km,
  }));
  const oilViscosityOptions = oilViscosity.power.filter(Boolean).map((viscosity) => ({
    label: viscosity,
    value: viscosity,
  }));
  return (
    <Fragment>
      <SelectItem
        placeholder={t('oil_km')}
        value={oilKmOptions.find((km) => km.value === selectedOilKm) || null}
        options={oilKmOptions}
        isClearable
        onChange={(option: any) => {
          setSelectedOilKm(option?.value || null);
          setCurrent(1);
        }}
      />
      <SelectItem
        placeholder={t('oil_viscosity')}
        value={oilViscosityOptions.find((viscosity) => viscosity.value === selectedOilViscosity) || null}
        options={oilViscosityOptions}
        onChange={(option: any) => {
          setSelectedOilViscosity(option.value);
          setCurrent(1);
        }}
      />
    </Fragment>
  );
});
